// ABOUTME: Resolves the hierarchy node a model-selection product card should favorite.
// ABOUTME: The catalog mixes hierarchies — configurable products are prototypes, the others models;
// ABOUTME: a family or series card is its model-selection node, addressed by its id.

export interface ProductFavoriteHierarchies {
    model?: string | null;
    prototype?: string | null;
}

export interface ProductFavoriteTarget {
    hierarchyId: string;
    nodeId: string;
}

interface FavoritableProduct {
    id: string;
    isConfigurable?: boolean;
}

/**
 * Returns the `{ hierarchyId, nodeId }` pair the favorite toggle has to address for a catalog
 * product, or `undefined` when the needed hierarchy is not configured or the card id cannot be
 * decoded. `isConfigurable` defaults to `true`, matching `ModelSelectionWidget.handleProductClick`.
 */
export function resolveProductFavoriteTarget(
    product: FavoritableProduct,
    hierarchies: ProductFavoriteHierarchies,
): ProductFavoriteTarget | undefined {
    const hierarchyId = product.isConfigurable ?? true ? hierarchies.prototype : hierarchies.model;
    if (!hierarchyId || !product.id) {
        return undefined;
    }
    try {
        const nodeId = decodeURIComponent(atob(product.id));
        return nodeId ? { hierarchyId, nodeId } : undefined;
    } catch {
        // A card id that is not the expected base64 of the node id (an overridden catalog export,
        // for instance) simply has no favorite target.
        return undefined;
    }
}

/**
 * The node id of a model-selection category card, decoded from its `id` like a product's, or
 * `undefined` when it cannot be decoded. Not its `internalId`: that is the node code, which a
 * rename changes while the node id, and so its favorite, stays.
 */
export function resolveCategoryNodeId(category: { id: string }): string | undefined {
    if (!category.id) {
        return undefined;
    }
    try {
        return decodeURIComponent(atob(category.id)) || undefined;
    } catch {
        return undefined;
    }
}
